import { SnackbarProvider as SnackbarProviderNotistack, closeSnackbar } from 'notistack';
import { Outlet } from 'react-router-dom';
import {ReactElement} from "react";
import {IconButton} from "@mui/material";
import { XIcon } from '@phosphor-icons/react';

interface SnackbarProviderProps {
  children?: ReactElement;
}

function SnackbarProvider({ children }: SnackbarProviderProps) {
  return (
    <SnackbarProviderNotistack
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      action={(snackbarId) => (
        <IconButton
          size="small"
          onClick={() => closeSnackbar(snackbarId)}
          color="inherit"
        >
          <XIcon />
        </IconButton>
      )}>
      {children}
      <Outlet />
    </SnackbarProviderNotistack>
  )
}

export default SnackbarProvider;














